import axios from "axios";

import endPoints from "../../../../../config/endPoints";

export const getAllAgenciesApi = async(reqBody) => 
{  
  return await axios.post(endPoints.agency, reqBody);  
}
